var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsSettings = function SvgSmsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sms_settings_svg2__a",
    x1: 33.03,
    x2: 169.03,
    y1: 154.2,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_settings_svg2__a",
    id: "sms_settings_svg2__b",
    x1: 45.87,
    x2: 181.87,
    y1: 167.63,
    y2: 37.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_settings_svg2__a",
    id: "sms_settings_svg2__c",
    x1: 33.52,
    x2: 169.52,
    y1: 154.72,
    y2: 24.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_settings_svg2__a",
    id: "sms_settings_svg2__d",
    x1: 20.79,
    x2: 156.79,
    y1: 141.39,
    y2: 11.39,
    gradientTransform: "rotate(45 60.406 103.531)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sms_settings_svg2__a",
    id: "sms_settings_svg2__e",
    x1: 29.04,
    x2: 165.04,
    y1: 150.02,
    y2: 20.02
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M147.47 42.93H25.8C11.57 42.97.04 54.5 0 68.73v102.53c.04 6.87 5.6 12.43 12.47 12.47 2.71.02 5.35-.85 7.53-2.46L42.87 164c.93-.69 2.05-1.07 3.2-1.07h101.47c14.26-.04 25.8-11.61 25.8-25.87V68.73c-.04-14.26-11.61-25.8-25.87-25.8m12.52 94.15c0 6.92-5.61 12.53-12.53 12.53H46.06c-4.04.02-7.96 1.32-11.2 3.73l-21.53 16.27V68.74c.04-6.87 5.6-12.43 12.47-12.47h121.72c6.87.05 12.43 5.61 12.47 12.48z",
    style: {
      fill: "url(#sms_settings_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.93,
    cy: 103.53,
    r: 6.67,
    style: {
      fill: "url(#sms_settings_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.07,
    cy: 103.53,
    r: 6.67,
    style: {
      fill: "url(#sms_settings_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4,
    cy: 103.53,
    r: 6.67,
    style: {
      fill: "url(#sms_settings_svg2__d)"
    },
    transform: "rotate(-45 60.395 103.534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2 16.26H40c-3.69 0-6.67 2.98-6.67 6.67S36.32 29.6 40 29.6h134.19c6.87.04 12.43 5.6 12.47 12.47v67.53c0 3.69 2.99 6.67 6.67 6.67 3.69-.01 6.67-3 6.67-6.68V42.06c-.04-14.23-11.57-25.76-25.8-25.8",
    style: {
      fill: "url(#sms_settings_svg2__e)"
    }
  }));
};
export default SvgSmsSettings;